module.exports = __webpack_public_path__ + "img/logo128pxCarre.8909971e.png";